export enum ElementAttribute {
    id, class
}
